import React, {Component} from 'react';

import {APIGatewayClientContext} from '../provider/APIGatewayClientProvider';
import NotFound404 from '../error/NotFound404';
import DataLoading from '../homepage/DataLoading';

const IS_WORK_VIEW_ENABLED_KEY = 'isWorkViewEnabled';

/**
 * Route guard that only renders the wrapped component if the work view
 * feature flag is enabled for the current warehouse. Renders 404 otherwise.
 */
export default function WorkViewRouteGuard(WrappedComponent) {
    class WorkViewGuard extends Component {

        static contextType = APIGatewayClientContext;

        constructor(props) {
            super(props);
            this.state = {
                isLoading: true,
                isWorkViewEnabled: false
            };
        }

        componentDidMount() {
            this.checkFeatureFlag();
        }

        componentDidUpdate(prevProps) {
            const prevWarehouseId = prevProps.match.params.warehouseId;
            const currentWarehouseId = this.props.match.params.warehouseId;
            if (prevWarehouseId !== currentWarehouseId) {
                this.checkFeatureFlag();
            }
        }

        checkFeatureFlag() {
            const warehouseId = this.props.match.params.warehouseId;
            if (!warehouseId) {
                this.setState({isLoading: false, isWorkViewEnabled: false});
                return;
            }
            this.setState({isLoading: true});
            this.context.client.getCustomConfigurationsByWarehouseId(warehouseId)
                .then(response => {
                    const configurations = response.data.warehouseCustomConfigurations;
                    const isWorkViewEnabled = configurations && configurations[IS_WORK_VIEW_ENABLED_KEY] === 'true';
                    this.setState({isLoading: false, isWorkViewEnabled});
                })
                .catch(() => {
                    this.setState({isLoading: false, isWorkViewEnabled: false});
                });
        }

        render() {
            if (this.state.isLoading) {
                return <DataLoading/>;
            }
            if (!this.state.isWorkViewEnabled) {
                return <NotFound404/>;
            }
            return <WrappedComponent {...this.props}/>;
        }
    }

    return WorkViewGuard;
}
